<template>
  <div>
    <div
      class="instruction_title text-left para-mrgn-20"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedBody`,
        val: lang,
        html: question.formattedBody
      }"
      v-html="question.formattedBody"
    ></div>
    <div class="modal-body form-group m-0" @click.once="$emit('onClick', question)">
      <datepicker class="date_sec d-inline-block" v-if="componentData.type == 'Date' || componentData.type == 'DateTime'" v-model="question.date" :placeholder="componentData.dateFormat" :format="componentData.dateFormat.replace('mm', 'MM')" :disabled-dates="dateRange()" :disabled="isFieldDisabled" :language="calenderLang" name="startDate"> </datepicker>
      <vue-timepicker class="time_sec d-inline-block" v-if="componentData.type == 'Time' || componentData.type == 'DateTime'" v-model="question.time" hide-clear-button hide-disabled-minutes :format="componentData.timeFormat == '12' ? 'hh:mm A' : 'HH:mm'" name="startTime" :disabled="isFieldDisabled" :key="question.identifier"> </vue-timepicker>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import langTranslate from "./lang-translate";
import * as calenderLanguage from "vuejs-datepicker/dist/locale";
import { Widget } from "@/components/services/participant-service";
import moment from "moment";

export default {
  name: "date-time",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: "",
      calenderLang: calenderLanguage.en,
      widget: new Widget()
    };
  },
  components: {
    Datepicker,
    VueTimepicker
  },
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  watch: {
    question(val) {
      if (val) {
        this.question.date = moment().format(this.getFormattedDate(this.question.constraints.dateFormat));
        this.question.time = moment().format(this.question.constraints.timeFormat == "12" ? "hh:mm A" : "HH:mm");
        this.$forceUpdate();
      }
    }
  },
  mounted() {
    const calLang = this.widget.getCalendarLanguageAvailable();
    this.calenderLang = calenderLanguage[calLang];
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  methods: {
    getFormattedDate(format) {
      switch (format) {
        case "dd/mm/yyyy":
          return "D MMMM YYYY";
        case "mm/dd/yyyy":
          return "MMMM D YYYY";
        case "yyyy/mm/dd":
          return "YYYY MMMM D";
        default:
          return "D MMMM YYYY";
      }
    },
    timeRance() {
      if (this.componentData.showTimeRange) {
        if (this.componentData.timeFormat == "24") {
          const start = new Date();
          const end = new Date();
          start.setTime(this.componentData.startTime);
          end.setTime(this.componentData.endTime);
        } else {
        }
      } else {
        return {};
      }
    },
    dateRange() {
      if (this.componentData.showDateRange && Object.keys(this.componentData).includes("startDate") && Object.keys(this.componentData).includes("endDate")) {
        return {
          to: new Date(moment(this.componentData.startDate)),
          from: new Date(moment(this.componentData.endDate))
        };
      }
      if (this.componentData.showDateRange && Object.keys(this.componentData).includes("daysBefore") && Object.keys(this.componentData).includes("daysAfter")) {
        const dateFrom = new Date(this.componentData.targetDate);
        const dateTo = new Date(this.componentData.targetDate);
        dateFrom.setDate(dateFrom.getDate() + Math.abs(this.componentData.daysAfter));
        dateTo.setDate(dateTo.getDate() - Math.abs(this.componentData.daysBefore));
        return {
          to: dateTo,
          from: dateFrom
        };
      } else {
        return {};
      }
    },
    validateInput() {
      this.$nextTick(() => {
        if (this.componentData.showDate && this.componentData.showTime) {
          this.onDateObjChange();
          if (this.hasFieldError == false) {
            this.onTimeChange();
          }
          if (this.hasFieldError == false) {
            this.validateDateRules();
          }
          if (this.hasFieldError == false) {
            this.validateTimeRules();
          }
        } else if (this.componentData.showDate) {
          this.onDateObjChange();
          if (this.hasFieldError == false) {
            this.validateDateRules();
          }
        } else if (this.componentData.showTime) {
          this.onTimeChange();
          if (this.hasFieldError == false) {
            this.validateTimeRules();
          }
        }
        if (this.hasFieldError == false) {
          this.onAnswerChange();
        }
      });
    },
    onDateObjChange() {
      this.validateDate();
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    clearAnswer(){
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.question.answer = undefined;
      this.question.date = moment().format(this.getFormattedDate(this.question.constraints.dateFormat));
      this.question.time = moment().format(this.question.constraints.timeFormat == '12' ? 'hh:mm A' : 'HH:mm');
    }
  },
};
</script>

<style></style>
